import moment from 'moment';

export const formatDate = (iso: string): string => {
  return moment(iso).format('DD-MM-YYYY');
};

export const formatDateTime = (iso: string): string => {
  return moment(iso).format('DD-MM-YYYY HH:mm');
};

export const formatDateTimeWithSeconds = (iso: string): string => {
  return moment(iso).format('DD-MM-YYYY HH:mm:ss');
};